import Notification from '@stimulus-components/notification'

export default class extends Notification {
  connect() {
    // Set default delay to match the animation duration (5 seconds)
    if (!this.hasDelayValue) {
      this.delayValue = 5000;
    }
    
    super.connect();
  }

  hide() {
    super.hide();
  }
  
  get hasDelayValue() {
    return this.hasOwnProperty('delayValue');
  }
}
